'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SessionExpiredError=require('../../../dist-es6/client/services/errors/sessionExpiredError');
const AccessDeniedError=require('../../../dist-es6/client/services/errors/accessDeniedError');
const AppReloadRequiredError=require('../../../dist-es6/client/services/errors/appReloadRequiredError');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');let

HandleUncaughtErrorsAnnotation=function(){
function HandleUncaughtErrorsAnnotation(){let errorToResult=arguments.length>0&&arguments[0]!==void 0?arguments[0]:_.noop;_classCallCheck(this,HandleUncaughtErrorsAnnotation);
this._errorToResult=errorToResult;
}_createClass(HandleUncaughtErrorsAnnotation,[{key:'errorToResult',get:function()

{
return this._errorToResult;
}}]);return HandleUncaughtErrorsAnnotation}();let


UncaughtErrorHandler=function(_BaseService){_inherits(UncaughtErrorHandler,_BaseService);_createClass(UncaughtErrorHandler,null,[{key:'$inject',get:function()
{
return['errorHandlers'];
}}]);

function UncaughtErrorHandler(errorHandlers){_classCallCheck(this,UncaughtErrorHandler);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._errorHandlers=errorHandlers;return _this;
}UncaughtErrorHandler.prototype.

_wrap=function _wrap(instance,asyncAction,errorToResult){var _this2=this;
return function(){var ref=_asyncToGenerator(function*(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}
try{
return yield asyncAction.apply(instance,args);
}catch(e){
const handler=_this2._errorHandlers.handlerFor(e);
if(_.exists(handler)){
handler(e);
return errorToResult(e);
}
throw e;
}
});return function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2]}return ref.apply(this,arguments)}}();
};UncaughtErrorHandler.prototype.

applyTo=function applyTo(instance){
const prototype=instance.constructor.prototype;
const propertyNames=Object.getOwnPropertyNames(prototype);
for(const propertyName of propertyNames){
if(_.attempt(function(){return prototype[propertyName]})instanceof Error||
typeof prototype[propertyName]!='function'){
continue;
}

const propertyAnnotations=tryGet(prototype,`["${propertyName}"].annotations`).otherwise([]);
const relevantAnnotation=_.find(propertyAnnotations,function(annotation){return annotation instanceof HandleUncaughtErrorsAnnotation});
if(_.exists(relevantAnnotation)){
instance[propertyName]=this._wrap(instance,instance[propertyName],relevantAnnotation.errorToResult);
}
}
};return UncaughtErrorHandler}(BaseService);


module.exports=UncaughtErrorHandler;
module.exports.Annotations={
HandleUncaughtErrors:function(_potentialErrorToResultOrTarget,undefinedOrKey,undefinedOrDescriptor){
if(arguments.length===3){


const descriptor=undefinedOrDescriptor;

const annotation=new HandleUncaughtErrorsAnnotation;
descriptor.value.annotations=_addAnnotation(descriptor,annotation);
descriptor.kind='method';

return descriptor;
}else{
return function(target,key,descriptor){
const annotation=new HandleUncaughtErrorsAnnotation(_potentialErrorToResultOrTarget);
descriptor.value.annotations=_addAnnotation(descriptor,annotation);
descriptor.kind='method';

return descriptor;
};
}

}};


function _addAnnotation(descriptor,annotation){
return tryGet(descriptor,'value.annotations').
then(function(a){return a.push(annotation)}).
otherwise([annotation]);
}
//# sourceMappingURL=uncaughtErrorHandler.js.map
